module.exports = __webpack_public_path__ + "img/article-gb-other-1.8d574b11.png";